/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Reportingapikeys_Explainer2Inputs */

const en_settings_reportingapikeys_explainer2 = /** @type {(inputs: Settings_Reportingapikeys_Explainer2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage users' API keys for programmatic access to the external reporting APIs. Keys authenticate requests via the Vega-Api-Key header and are scoped to the owning user's data.`)
};

/**
* | output |
* | --- |
* | "Manage users' API keys for programmatic access to the external reporting APIs. Keys authenticate requests via the Vega-Api-Key header and are scoped to the o..." |
*
* @param {Settings_Reportingapikeys_Explainer2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_reportingapikeys_explainer2 = /** @type {((inputs?: Settings_Reportingapikeys_Explainer2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Reportingapikeys_Explainer2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_reportingapikeys_explainer2(inputs)
});
export { settings_reportingapikeys_explainer2 as "settings_reportingApiKeys_explainer" }